import resultListStore from './resultListStore';
import bannerTopStore from './bannerTopStore';
import checkListStore from './checkListStore';

export default {
  resultListStore,
  bannerTopStore,
  checkListStore
};


// WEBPACK FOOTER //
// ./src/store/index.js